<template>
  <form subtitle color="#3498db" finish-button-text="Enroll Now">
    <b-row v-if="!modalPopup">
      <b-col class="col-12 col-sm-12 text-center text-sm-left p-0 pt-0 pt-sm-1 pt-md-2 pt-lg-3">
        <b-img
                :src=logoUrl alt="logo" class="imgLogo"></b-img>
        <div class="titleBx" style="padding-top: 37px;float: left;margin-left: 10px;">
          <span class="customTitle" style="bottom:0px;">Provider Directory Search</span>
        </div>
      </b-col>

    </b-row>
    <hr v-if="!modalPopup"/>
      <div class="col-12">
        <b-form @submit.prevent="searchProvider" novalidate>
          <div class="col-12 text-right">

            <b-button class="btn-sm" variant="info" @click="decreaseFontSize()" :disabled="fontSize==12">A<sup>-</sup></b-button>
            <b-button class="btn-sm ml-1" variant="info" @click="increaseFontSize()" :disabled="fontSize==18" href="javascript:;">A<sup>+</sup></b-button>

          </div>
          <div class="float-left h-25 col-12 text-left tagBox">
            <span :style="cusFontSize"
              class="filterText"
              v-if="form.provSpecialty.length>0 || form.language.length>0 || form.gender.length>0 || form.wheelchair.length>0 || form.translator.length>0 || form.newpatient.length>0 || !!form.ageband"
            >Selected Filter:</span>
            <span :style="cusFontSize"
              type="button"
              class="selTags m-2 p-0"
              aria-label="Close"
              v-for="(each,i) in hospital"
              :key="each.value"
            >
              {{each}}
              <span :style="cusFontSize"
                aria-hidden="true"
                class="text-dark align-top closeTags"
                @click="removeThis(i,hospital)"
              >
                <sup :style="cusFontSize">
                  <i class="far fa-times-circle"></i>
                </sup>
              </span>
            </span>
            <span :style="cusFontSize"
              type="button"
              class="selTags m-2 p-0"
              aria-label="Close"
              v-for="(each,i) in form.provSpecialty"
              :key="each.value"
            >
              {{getProvSpecialty(each)}}
              <span :style="cusFontSize"
                aria-hidden="true"
                class="text-dark align-top closeTags"
                @click="removeThis(i,form.provSpecialty)"
              >
                <sup :style="cusFontSize">
                  <i class="far fa-times-circle"></i>
                </sup>
              </span>
            </span>
            <span :style="cusFontSize"
              type="button"
              class="selTags m-2 p-0"
              aria-label="Close"
              v-for="(lang,i) in form.language"
              :key="lang.value"
            >
              {{getLangName(lang)}}
              <span :style="cusFontSize"
                aria-hidden="true"
                class="text-dark align-top closeTags"
                @click="removeThis(i,form.language)"
              >
                <sup :style="cusFontSize">
                  <i class="far fa-times-circle"></i>
                </sup>
              </span>
            </span>
            <span :style="cusFontSize"
              type="button"
              class="selTags m-2 p-0"
              aria-label="Close"
              v-for="(lang,i) in form.gender"
              :key="lang.value"
            >
              {{lang}}
              <span :style="cusFontSize"
                aria-hidden="true"
                class="text-dark align-top closeTags"
                @click="removeThis(i,form.gender)"
              >
                <sup :style="cusFontSize">
                  <i class="far fa-times-circle"></i>
                </sup>
              </span>
            </span>
            <span :style="cusFontSize"
              type="button"
              class="selTags m-2 p-0"
              aria-label="Close"
              v-for="(lang,i) in form.wheelchair"
              :key="lang.value"
            >
              {{lang}}
              <span :style="cusFontSize"
                aria-hidden="true"
                class="text-dark align-top closeTags"
                @click="removeThis(i,form.wheelchair)"
              >
                <sup :style="cusFontSize">
                  <i class="far fa-times-circle"></i>
                </sup>
              </span>
            </span>
            <span :style="cusFontSize"
              type="button"
              class="selTags m-2 p-0"
              aria-label="Close"
              v-for="(lang,i) in form.newpatient"
              :key="lang.value"
            >
              {{lang}}
              <span :style="cusFontSize"
                aria-hidden="true"
                class="text-dark align-top closeTags"
                @click="removeThis(i,form.newpatient)"
              >
                <sup :style="cusFontSize">
                  <i class="far fa-times-circle"></i>
                </sup>
              </span>
            </span>
            <span :style="cusFontSize"
              type="button"
              class="selTags m-2 p-0"
              aria-label="Close"
              v-if="form.ageband"
            >
              <span v-if="form.ageband==1">Age(Below 30)</span>
              <span v-if="form.ageband==2">Age(30-40)</span>
              <span v-if="form.ageband==3">Age(40-50)</span>
              <span v-if="form.ageband==4">Age(50-60)</span>
              <span v-if="form.ageband==5">Age(Above 60)</span>

              <span :style="cusFontSize"
                aria-hidden="true"
                class="text-dark align-top closeTags"
                @click="removeAge()"
              >
                <sup :style="cusFontSize">
                  <i class="far fa-times-circle"></i>
                </sup>
              </span>
            </span>
          </div>
          <div class="clearfix"></div>
          <b-row>
            <b-col cols="12" sm="6" md="6" lg="4" xl="4"  class="text-right inner-box-right pt-3 pr-3 pl-3 pb-0">
              <b-row>
                <b-col class="p-1 col-12">
                  <b-form-group
                    label-cols="4"
                    class="mb-1"
                    id="input-group-5"
                    label="Provider Name:"
                    label-for="input-2"
                    label-class="float-left customLabel"
                    :style="cusFontSizeSelect"
                  >
                    <b-form-input
                      v-model="form.providername"
                      id="input-2"
                      required
                      size="sm"
                      placeholder="Provider First Name or Last Name"
                      :style="cusFontSize"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label-cols="4"
                    class="mb-1"
                    id="input-group-6"
                    label="Hospital / IPA:"
                    label-for="input-2"
                    label-class="float-left customLabel"
                    :style="cusFontSizeSelect"
                  >
                    <b-form-input
                      v-model="form.provHospital"
                      id="input-2"
                      size="sm"
                      placeholder="Hospital/IPA"
                      :style="cusFontSizeSelect"
                    ></b-form-input>
                  </b-form-group>
                  <div class="zipBoxSm">
                    <b-form-group
                            label-cols="4"
                            class="mb-1 pl-0"
                            id="input-group-1"
                            label="Zip Code:"
                            label-for="input-2"
                            label-class="text-right customLabel"
                            :style="cusFontSizeSelect"
                    >
                      <b-form-input
                              id="input-2"
                              placeholder="Zip Code"
                              v-model="form.zipCode"
                              size="sm"
                              class="col-4 m-0 pt-0 pb-0 pl-1 pr-0 mr-0"
                              :style="cusFontSizeSelect"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                            label-cols="4"
                            class="mb-1 pl-0 text-left"
                            id="input-group-2"
                            label="Within:"
                            label-for="input-1"
                            label-class="text-right customLabel"
                            :style="cusFontSizeSelect"
                    >
                      <b-form-select
                              id="input-1"
                              v-model="form.zipMiles"
                              class="selectCust1"
                              :options="milesData"
                              ref="zipMiles"
                              size="sm"
                              :style="cusFontSizeSelect"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="6" md="6" lg="5" xl="5" class="text-right inner-box-right p-3">
              <b-row>
                <b-col cols="6" sm="6" md="6" lg="4" xl="4" class="p-1" @mouseleave="mouseOut('specialty')">
                  <a @click="toggleShow('specialty')" class="anchor text-light p-1" :style="cusFontSizeSelect">Specialty(s)</a>
                  <div v-if="showSpecialtyMenu" class="menu pt-1" :style="cusFontSizeSelect">
                    <b-form-input
                      v-model="specialtyInput"
                      class="m-0"
                      size="sm"
                      @keyup="searchSpec(specialtyInput)"
                      placeholder="Type to search"
                    ></b-form-input>
                    <b-form-checkbox-group
                      v-model="form.provSpecialty"
                      :options="specialtyFilter"
                      name="flavour-2a"
                      button-variant="success"
                      stacked
                    ></b-form-checkbox-group>
                  </div>
                </b-col>
                <b-col cols="6" sm="6" md="6" lg="4" xl="4"  class="p-1" @mouseleave="mouseOut('language')">
                  <!--                          @mouseleave="mouseOut('language')"-->
                  <a @click="toggleShow('language')" class="anchor text-light p-1" :style="cusFontSizeSelect">Language(s)</a>
                  <div v-if="showLanguageMenu" class="menu pt-1" :style="cusFontSizeSelect">
                    <b-form-input
                      v-model="languageInput"
                      class="m-0"
                      size="sm"
                      @keyup="searchLang(languageInput)"
                      placeholder="Type to search"
                    ></b-form-input>
                    <b-form-checkbox-group
                      v-model="form.language"
                      :options="languageFilter"
                      name="flavour-2a"
                      button-variant="success"
                      stacked
                    ></b-form-checkbox-group>
                  </div>
                </b-col>
                <b-col cols="6" sm="6" md="6" lg="4" xl="4" class="p-1" @mouseleave="mouseOut('gender')">
                  <a @click="toggleShow('gender')" class="anchor text-light p-1" :style="cusFontSizeSelect">Gender</a>
                  <div v-if="showGenderMenu" class="menu" :style="cusFontSizeSelect">
                    <b-form-checkbox-group
                      v-model="form.gender"
                      :options="[{text:'Male',value:'Male'},
                                                {text:'Female',value:'Female'},
                                                ]"
                      @click="showMenu !=showMenu;"
                      name="flavour-2a"
                      button-variant="success"
                      stacked
                    ></b-form-checkbox-group>
                  </div>

                </b-col>
                <b-col cols="6" sm="6" md="6" lg="4" xl="4" class="p-1" @mouseleave="mouseOut('wheelchair')">
                  <a @click="toggleShow('wheelchair')" class="anchor text-light p-1" :style="cusFontSizeSelect">Wheelchair Access</a>
                  <div v-if="showWheelchairMenu" class="menu" :style="cusFontSizeSelect">
                    <b-form-checkbox-group
                      v-model="form.wheelchair"
                      :options="[{text:'Yes',value:'Wheelchair Access (Yes)'},
                                            {text:'No',value:'Wheelchair Access (No)'},
                                            ]"
                      name="flavour-2a"
                      button-variant="success"
                      stacked
                    ></b-form-checkbox-group>
                  </div>
                </b-col>
                <b-col cols="6" sm="6" md="6" lg="6" xl="4" class="p-1" @mouseleave="mouseOut('newpatient')">
                  <a
                    @click="toggleShow('newpatient')"
                    class="anchor text-light p-1" :style="cusFontSizeSelect"
                  >Accepting Patients</a>
                  <div v-if="showNewpatientMenu" class="menu" :style="cusFontSizeSelect">
                    <b-form-checkbox-group
                      v-model="form.newpatient"
                      :options="[{text:'Yes',value:'Accepting Patients (Yes)'},
                                            {text:'No',value:'Accepting Patients (No)'},
                                            ]"
                      name="flavour-2a"
                      button-variant="success"
                      stacked
                    ></b-form-checkbox-group>
                  </div>
                </b-col>
                <b-col cols="6" sm="6" md="6" lg="4" xl="4" class="p-1" @mouseleave="mouseOut('age')">
                  <a @click="toggleShow('age')" class="anchor text-light p-1" :style="cusFontSizeSelect">Age Band</a>
                  <div v-if="showAgeMenu" class="menu" :style="cusFontSizeSelect">
                    <b-form-radio-group
                            v-model="form.ageband"
                            :options="[{text:'Below 30',value:'1'},
                                                {text:'30-40',value:'2'},{text:'40-50',value:'3'},{text:'50-60',value:'4'},{text:'Above 60',value:'5'}
                                                ]"
                            @click="showMenu !=showMenu;"
                            name="flavour-2a"
                            button-variant="success"
                            stacked
                    ></b-form-radio-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="12" md="12" lg="3" xl="3" class="pt-3 pr-3 pl-3 pb-0 zipBoxLg">
              <b-form-group
                      label-cols="3"
                      class="mb-1 pl-0"
                      id="input-group-3"
                      label="Zip Code:"
                      label-for="input-2"
                      label-class="text-right customLabel"
                      :style="cusFontSizeSelect"
              >
                    <b-form-input
                            id="input-2"
                            placeholder="Zip Code"
                            v-model="form.zipCode"
                            size="sm"
                            class="col-4 col-lg-6 m-0 pt-0 pb-0 pl-1 pr-0 mr-0"
                            :style="cusFontSizeSelect"
                    ></b-form-input>
              </b-form-group>
              <b-form-group
                      label-cols="3"
                      class="mb-1 pl-0 text-left"
                      id="input-group-4"
                      label="Within:"
                      label-for="input-1"
                      label-class="text-right customLabel"
                      :style="cusFontSizeSelect"
              >
                <b-form-select
                        id="input-1"
                        v-model="form.zipMiles"
                        class="selectCust1"
                        :options="milesData"
                        ref="zipMiles"
                        size="sm"
                        :style="cusFontSizeSelect"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12">
              <br/>
<!--              <b-button-->
<!--                  type="submit"-->
<!--                  @click="form.FacilitySearch = 1; removeSearchParamsNotForFacility()"-->
<!--                  class="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-2 btn btn-info btn-sm float-center mt-2 mr-2"-->
<!--                  :style="cusFontSizeSelect"-->
<!--                  :disabled="loading"-->
<!--                  v-if="!modalPopup"-->
<!--              >Search Facilities</b-button>&nbsp;-->
              <b-button
                      type="submit"
                      @click="form.FacilitySearch = 0"
                      class="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-2 btn btn-info btn-sm float-center mt-2 mr-2"
                      :style="cusFontSizeSelect"
                      :disabled="loading"
              >Search Providers</b-button>&nbsp;
              <b-button
                      class="col-4 col-xs-4 col-sm-4 col-md-2 col-lg-1 btn btn-secondary btn-sm float-center mt-2"
                      @click="clearAll"
                      :style="cusFontSizeSelect"
                      :disabled="loading"
              >Clear</b-button>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <hr />
      <b-row v-if="providers.length == 0 && loading">
        <b-col class="spinner">
          <semipolar-spinner :animation-duration="2000" :size="50" color="#25a7ce" />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12" v-if="providers.length>0">
          <b-row class="mr-3 p-0 mb-3">
            <b-col cols="6" sm="8" md="8" lg="8" class="text-left pr-0">
              <div class="d-inline customLabel" :style="cusFontSize">Show&nbsp;</div>
              <b-form-select
                      id="input-1"
                      v-model="form.limit"
                      class="selectCust1"
                      :options="recordLimitData"
                      ref="zipMiles"
                      :style="cusFontSize"
                      @change="searchProvider('P')"
              ></b-form-select>
              <div class="d-inline customLabel" :style="cusFontSize">&nbsp;records.</div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" class="float-right" :style="cusFontSize">
              <b-button variant="info btn-sm col-3 col-sm-4 float-right ml-1" @click="searchProvider('N')" v-if="recordCount>form.limit"><span :style="cusFontSize" class="hiddenSm text-white font-weight-light">Next</span> <i class="fas fa-angle-double-right"></i></b-button>
              <b-button variant="info btn-sm col-3 col-sm-4 float-right" @click="searchProvider('P')" v-if="form.currentPage>0"><i class="fas fa-angle-double-left"></i> <span :style="cusFontSize" class="hiddenSm  text-white font-weight-light">Previous</span></b-button>
<!--              <b-link class="text-success float-right" @click="searchProvider('N')" v-if="recordCount>form.limit"><i class="fas fa-caret-square-right"></i></b-link>-->
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="providers.length > 0">
         <b-col col=12 class="text-left">
           <span>Product{{form.products.length>1 ? 's' : '' }}:</span>
           <span :style="cusFontSize"
                 type="button"
                 class="textDesc p-0 text-left m-1"
                 aria-label="Close"
                 v-for="(each,i) in form.products"
                 :key="each"
           >
              &nbsp;{{each}}{{form.products.length==1 || i==form.products.length-1 ? '' : ','}}
           </span>
         </b-col>
      </b-row>
      <b-row class="text-left p-3" v-if="providers.length > 0">
        <b-card class="mb-3 col-12 provrow" v-for="(prov, index) in providers" :key="index" @click="emitProvDetails(prov)" :style="customCard">
          <b-card-text>
            <b-row>
              <b-col cols="12" class="col-sm-12 col-md-5">
                <b-row>
                  <b-col class="col-2 custPadding hiddenXs" sm="3">
                    <b-img
                      :src=maleUrl
                      fluid
                      alt="Male Doctor"
                      v-if="prov.Gender == 'M' && prov.ProviderID"
                    ></b-img>
                    <b-img
                      :src=femaleUrl
                      fluid
                      alt="Female Doctor"
                      v-if="prov.Gender == 'F' && prov.ProviderID"
                    ></b-img>
                    <b-img
                      :src=doctorUrl
                      fluid
                      alt="Doctor"
                      v-if="prov.Gender != 'F' && prov.Gender != 'M' && prov.ProviderID"
                    ></b-img>
                    <b-img
                            :src=hospitalUrl
                            fluid
                            alt="Hospital"
                            v-if="!prov.ProviderID"
                    ></b-img>
                  </b-col>
                  <b-col class="col-10" sm="9">
                    <span :style="cusFontSize" class="font-weight-bold">
                      <h3
                        class="custFontHeader"
                        :style="cusHeaderFontSize"
                      >
                      <span v-if="prov.ProviderID">{{prov.ProviderFirstName}} {{prov.ProviderLastName}}</span>
                      <span v-if="!prov.ProviderID">{{prov.HospitalName}}</span>
                      </h3>
                    </span>
                    <span :style="cusFontSize" class="font-weight-bold" title="Gender" v-if="prov.ProviderID">
                      <i class="fas fa-venus-mars"></i>
                    </span>
                    <span :style="cusFontSize" class="ml-1 font-weight-normal" v-if="prov.ProviderID">
                      {{prov.Gender=='F'?'Female':(prov.Gender=='M'?'Male':'Unknown')}}
                    </span>
                    <span :style="cusFontSize" class="font-weight-normal ml-1" v-if="prov.ProviderID">
                      <b>Age</b> {{prov.Age}}
                      <br/>
                    </span>
                    <span :style="cusFontSize" class="font-weight-bold" title="Address">
                      <i class="fas fa-address-book"></i>
                    </span>
                    <span :style="cusFontSize" class="ml-1 font-weight-normal">
                      {{prov.Street1}}{{prov.Street2?', '+prov.Street2 : ''}}{{prov.City?', '+prov.City:''}}{{prov.State?', '+prov.State:''}}&nbsp;{{prov.Zip}}{{prov.distance?', '+prov.distance:''}}
                      <b-link target="_blank" :href="prov.latLong">
                        <i class="ti-location-pin"></i>Map
                      </b-link>
                    </span>
                    <br />
                    <span :style="cusFontSize" class="font-weight-bold" title="Phone">
                      <i class="fa fa-phone-alt"></i>&nbsp;
                    </span>
                    <span :style="cusFontSize"
                      v-if="prov.Phone"
                      class="ml-1 font-weight-normal"
                    >{{prov.Phone | VMask('(###)-###-####')}}</span>
                    <span :style="cusFontSize" v-if="!prov.Phone" class="ml-1 font-weight-normal">N/A</span>

                    <span :style="cusFontSize" class="font-weight-bold ml-3"  title="Fax">
                      <i class="fa fa-fax"></i>&nbsp;
                    </span>
                    <span :style="cusFontSize"
                      v-if="prov.Fax"
                      class="ml-1 font-weight-normal"
                    >{{prov.Fax | VMask('(###)-###-####')}}</span>
                    <span :style="cusFontSize" v-if="!prov.Fax" class="ml-1 font-weight-normal">N/A</span>
                    <br />
                    <span :style="cusFontSize" class="font-weight-bold" title="Email">
                      <i class="fa fa-envelope" ></i>&nbsp;
                    </span>
                    <span :style="cusFontSize" v-if="prov.Email" class="ml-1 font-weight-normal">
                      <a :href="'mailto:'+prov.Email">{{prov.Email}}</a>
                    </span>
                    <span :style="cusFontSize" v-if="!prov.Email" class="ml-1 font-weight-normal">N/A</span>
                    <br />
                    <span :style="cusFontSize" class="font-weight-bold" title="PCP" v-if="prov.ProviderID">
                      PCP:
                    </span>
                    <span :style="cusFontSize" title="PCP" v-if="prov.ProviderID">
                       {{prov.IsPrimaryCarePhysician==1?'Yes':'No'}}
                    </span>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" class="col-sm-12 col-md-4">
                <span :style="cusFontSize" class="font-weight-bold">Specialty:&nbsp;</span>
                <span class="textDesc" :style="cusFontSize" v-if="prov.ProviderID">
                    {{prov.PrimarySpecialtyName}} {{prov.OtherSpecialtyName1?', '+prov.OtherSpecialtyName1:''}} {{prov.OtherSpecialtyName2?', '+prov.OtherSpecialtyName2:''}} {{prov.OtherSpecialtyName3?', '+prov.OtherSpecialtyName3:''}} {{prov.OtherSpecialtyName4?', '+prov.OtherSpecialtyName4:''}}<br />
                </span>
                <span class="textDesc" :style="cusFontSize" v-if="!prov.ProviderID">
                    {{prov.PrimarySpecialtyName ? prov.PrimarySpecialtyName : 'N/A'}}<br/>
                </span>

                <span :style="cusFontSize" class="font-weight-bold" v-if="prov.ProviderID">Hospital Affiliation:&nbsp;</span>
                <span :style="cusFontSize" class="textDesc" v-if="prov.ProviderID">{{prov.HospitalName}}<br /></span>
                <span :style="cusFontSize" class="font-weight-bold">IPA:&nbsp;</span>
                <span :style="cusFontSize" class="textDesc">{{prov.IPAName?prov.IPAName:'N/A'}}<br /></span>
                <span :style="cusFontSize" class="font-weight-bold" v-if="prov.ProviderID">PCPIPAID:&nbsp;</span>
                <span :style="cusFontSize" class="textDesc" v-if="prov.ProviderID">{{prov.PCPIPAID?prov.PCPIPAID:'N/A'}}<br /></span>
                <span :style="cusFontSize" class="font-weight-bold" v-if="prov.ProviderID">Accepting New Patients:&nbsp;</span>
                <span :style="cusFontSize"
                  :class="prov.AcceptingNewMember == 1?'text-success':prov.AcceptingNewMember == 0?'text-danger':'text-warning'"
                      v-if="prov.ProviderID"
                >
                  <span v-if="prov.AcceptingNewMember == 1" :style="cusFontSize" class="textDesc">Yes</span>
                  <span v-if="prov.AcceptingNewMember == 0" :style="cusFontSize" class="textDesc">No</span>
                  <span v-if="prov.AcceptingNewMember != 0 && prov.AcceptingNewMember != 1" :style="cusFontSize" class="textDesc">Unknown</span>
<!--                  <i-->
<!--                    class="fa fa-times"-->
<!--                    aria-hidden="true"-->
<!--                    v-if="prov.AcceptingNewMember == 0"-->
<!--                    title="No"-->
<!--                  ></i>-->
<!--                  <i-->
<!--                    class="fa fa-question"-->
<!--                    aria-hidden="true"-->
<!--                    v-if="prov.AcceptingNewMember != 0 && prov.AcceptingNewMember != 1"-->
<!--                    title="Unknown"-->
<!--                  ></i>-->
                  <br />
                </span>
                <span :style="cusFontSize" class="font-weight-bold">Wheelchair Access:&nbsp;</span>
                <span :style="cusFontSize"
                  :class="prov.WheelChairAccess == 1?'text-success':prov.WheelChairAccess == 0?'text-danger':'text-warning'"
                >
                  <span v-if="prov.WheelChairAccess == 1" :style="cusFontSize" class="textDesc">Yes</span>
                  <span v-if="prov.WheelChairAccess == 0" :style="cusFontSize" class="textDesc">No</span>
                  <span v-if="prov.WheelChairAccess != 0 && prov.WheelChairAccess != 1" :style="cusFontSize" class="textDesc">Unknown</span>
<!--                  <i-->
<!--                    class="fa fa-check"-->
<!--                    aria-hidden="true"-->
<!--                    v-if="prov.WheelChairAccess == 1"-->
<!--                    title="Yes"-->
<!--                  ></i>-->
<!--                  <i-->
<!--                    class="fa fa-times"-->
<!--                    aria-hidden="true"-->
<!--                    v-if="prov.WheelChairAccess ==  0"-->
<!--                    title="No"-->
<!--                  ></i>-->
<!--                  <i-->
<!--                    class="fa fa-question"-->
<!--                    aria-hidden="true"-->
<!--                    v-if="prov.WheelChairAccess != 0 && prov.WheelChairAccess != 1"-->
<!--                    title="Unknown"-->
<!--                  ></i>-->
                </span>
                <br />
                <span :style="cusFontSize" class="font-weight-bold" v-if="prov.ProviderID">Language(s):&nbsp;</span>
                <span class="textDesc" :style="cusFontSize" v-if="prov.ProviderID">{{prov.PrimaryLanguageName}} {{prov.SecondaryLanguageName?', '+prov.SecondaryLanguageName:''}} {{prov.OtherLanguageName?', '+prov.OtherLanguageName:''}}</span>
              </b-col>
              <b-col cols="12" class="col-sm-12 col-md-3 p-2 p-sm-0">
                <b-row>
                  <span class="hourBox text-primary pr-1" :style="cusFontSizeSelect">Mon</span>
                  <span :style="cusFontSizeSelect">{{(prov.MondayHoursFrom && prov.MondayHoursTo) ? prov.MondayHoursFrom+ ' - '+prov.MondayHoursTo : 'unknown'}}</span>
                </b-row>
                <b-row>
                  <span class="hourBox text-primary pr-1" :style="cusFontSizeSelect">Tue</span>
                  <span :style="cusFontSizeSelect">{{(prov.TuesdayHoursFrom && prov.TuesdayHoursTo) ? prov.TuesdayHoursFrom+' - '+prov.TuesdayHoursFrom: 'unknown'}}</span>
                </b-row>
                <b-row>
                  <span class="hourBox text-primary pr-1" :style="cusFontSizeSelect">Wed</span>
                  <span :style="cusFontSizeSelect">{{(prov.WednesdayHoursFrom && prov.WednesdayHoursTo) ? prov.WednesdayHoursFrom+' - '+prov.WednesdayHoursTo : 'unknown'}}</span>
                </b-row>
                <b-row>
                  <span class="hourBox text-primary pr-1" :style="cusFontSizeSelect">Thu</span>
                  <span :style="cusFontSizeSelect">{{(prov.ThursdayHoursFrom && prov.ThursdayHoursTo) ? prov.ThursdayHoursFrom+' - '+prov.ThursdayHoursTo : 'unknown'}}</span>
                </b-row>
                <b-row>
                  <span class="hourBox text-primary pr-1" :style="cusFontSizeSelect">Fri</span>
                  <span :style="cusFontSizeSelect">{{(prov.FridayHoursFrom && prov.FridayHoursTo) ? prov.FridayHoursFrom+' - '+prov.FridayHoursTo : 'unknown'}}</span>
                </b-row>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-row>
    <b-row>
      <b-col class="col-12" v-if="providers.length>0">
        <b-row class="mr-3 p-0 mb-3">
          <b-col cols="6" sm="8" md="8" lg="8" class="col-4 text-left pr-1">
            <div class="d-inline customLabel" :style="cusFontSize">Show&nbsp;</div>
            <b-form-select
                    id="input-1"
                    v-model="form.limit"
                    class="selectCust1"
                    :options="recordLimitData"
                    ref="zipMiles"
                    :style="cusFontSize"
                    @change="searchProvider('P')"
            ></b-form-select>
            <div class="d-inline customLabel" :style="cusFontSize">&nbsp;records.</div>
          </b-col>
          <b-col cols="6" sm="4" md="4" lg="4" class="float-right" :style="cusFontSize">
            <b-button variant="info btn-sm col-3 col-sm-4 float-right ml-1" @click="searchProvider('N')" v-if="recordCount>form.limit"><span :style="cusFontSize" class="hiddenSm text-white font-weight-light">Next</span> <i class="fas fa-angle-double-right"></i></b-button>
            <b-button variant="info btn-sm col-3 col-sm-4 float-right" @click="searchProvider('P')" v-if="form.currentPage>0"><i class="fas fa-angle-double-left"></i> <span :style="cusFontSize" class="hiddenSm  text-white font-weight-light">Previous</span></b-button>
            <!--              <b-link class="text-success float-right" @click="searchProvider('N')" v-if="recordCount>form.limit"><i class="fas fa-caret-square-right"></i></b-link>-->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
      <b-row v-if="searchFlag && !loading">
        <b-col>
          <h4 class="text-center">
            No provider matched your specified search criteria.
            <br />Please change your search criteria and try again.
          </h4>
          <!--          <h4>Please change the search parameters and try again.</h4>-->
        </b-col>
      </b-row>
      <b-row v-if="!searchCriteriaEntered && !loading">
        <b-col class="col-12 text-center">
          <h5 class="mt-2">Please enter at least one search criteria.</h5>
        </b-col>
      </b-row>
  </form>
  <!-- </ValidationObserver> -->
</template>

<script>
import ProviderSearchService from "../ProviderSearchService";
// import { FormWizard } from "vue-form-wizard";
// import Multiselect from 'vue-multiselect'

import { extend } from "vee-validate";
//import { required, alpha } from "vee-validate/dist/rules";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";
import { SemipolarSpinner } from "epic-spinners";
extend("confirmEmail", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Email confirmation does not match"
});
extend("atleastone", {
  validate(value) {
    return value > 0;
  },
  message: "Please select at least one statement."
});
extend("min-phnum", {
  validate(value) {
    if (value) {
      let phonenumberonly = value
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .replace(/-/g, "");
      return phonenumberonly.length == 10;
    }
  },
  message: "{_field_} should always be 10 digits"
});
export default {
  name: "ProviderSearch",
  components: {
    SemipolarSpinner
  },
  props:{
    modalPopup: Boolean
  },
  data() {
    // const now = new Date();
    return {
      logoUrl: '',
      doctorUrl: window.location.origin+'/images/stethoscope.png',
      maleUrl: window.location.origin+'/images/male-doc.png',
      femaleUrl: window.location.origin+'/images/female-doc.png',
      hospitalUrl: window.location.origin+'/images/hospital.png',
      fontSize: 10,
      fontSizeSelect: 10,
      headerFontSize: 14,
      activeInstrument: "Piano",
      instruments: [],
      products: [],
      providers: [],
      recordCount: 0,
      hospital: [],
      saveResp: [],
      searchFlag: false,
      searchCriteriaEntered: true,
      showMenu: false,
      showHospitalMenu: false,
      showProductMenu: false,
      showSpecialtyMenu: false,
      showLanguageMenu: false,
      showGenderMenu: false,
      showAgeMenu: false,
      showWheelchairMenu: false,
      showTranslatorMenu: false,
      showNewpatientMenu: false,
      center: {},
      markers: [],
      languageFilter: [],
      orgLanguages: [],
      languageInput: "",
      specialtyFilter: [],
      orgSpec: [],
      specialtyInput: "",
      loading: false,
      milesData: [
        //{ text: "", value: "" },
        { text: "5", value: "5" },
        { text: "10", value: "10" },
        { text: "15", value: "15" },
        { text: "20", value: "20" },
        { text: "25", value: "25" },
        { text: "30", value: "30" }
      ],
      recordLimitData: [
        { text: "10", value: "10" },
        { text: "20", value: "20" },
        { text: "30", value: "30" },
        { text: "40", value: "40" },
        { text: "50", value: "50" }
      ],
      form: {
        providername: "",
        provHospital: "",
        zipCode: "",
        zipMiles: 5,
        products: [],
        language: [],
        provSpecialty: [],
        newpatient: [],
        wheelchair: [],
        translator: [],
        gender: [],
        age: "",
        zipCodes: [],
        currentPage : 0,
        limit: 10,
        offset: 0
      }
    };
  },
  async created() {
    try {
      if(process.env.VUE_APP_CLIENT){
        this.logoUrl = window.location.origin+'/images/logos/'+process.env.VUE_APP_CLIENT+'.png';
      }else{
        this.logoUrl = window.location.origin+'/images/logos/logo.png';
      }
      this.products = await ProviderSearchService.getProducts();
      this.languageFilter = await ProviderSearchService.getLanguages();
      this.orgLanguage = this.languageFilter.slice();
      this.specialtyFilter = await ProviderSearchService.getProvSpecialities();
      this.orgSpec = this.specialtyFilter.slice();
      if(this.$route.params.id){
        var tempProd = window.atob(this.$route.params.id);
        tempProd = tempProd.split(',');
        this.form.products = tempProd;
      }


    } catch (err) {
      this.error = err.message;
    }
  },
  methods: {
    getLangName(lang){
      var selLang = this.orgLanguage.filter(function(item){
        return item.value === lang;
      });
      return selLang[0].text;
    },
    getProvSpecialty(spec){
      var selProv = this.orgSpec.filter(function(item){
        return item.value === spec;
      });
      return selProv[0].text;
    },
    clickCallback (pageNum){
      console.log(pageNum)
    },
    removeSearchParamsNotForFacility(){
      this.form.language=[];
      this.form.gender=[];
      this.form.newpatient=[];
      this.form.ageband="";
      this.form.providername="";
    },
    emitProvDetails(prov){
      if(this.modalPopup){
        this.$emit('providerselected', prov);
      }
    },
    nameWithLang({ name, language }) {
      return `${name} — [${language}]`;
    },
    removeDetails: function(checkVal, remArr) {
      //alert(checkVal)
      if (checkVal === "Y") {
        remArr.forEach(item => {
          delete this.form[item];
        });
      }
    },
    limitText(count) {
      return `and ${count} other countries`;
    },

    clearAll() {
      this.selectedCountries = [];
      (this.instruments = []), (this.form.products = []);
      this.form.provHospital = "";
      this.form.providername = "";
      this.form.zipCode = "";
      this.form.zipMiles = 5;
      this.form.provSpecialty = [];
      this.form.hospSpecialty = [];
      this.form.language = [];
      this.form.newpatient = [];
      this.form.wheelchair = [];
      this.form.translator = [];
      this.form.gender = [];
      this.form.ageband = "";
      this.searchFlag = false;
      this.searchCriteriaEntered = true;
      this.languageInput = "";
      this.specialtyInput = "";
      this.providers = [];
      this.recordCount = 0;
      this.searchLang(this.languageInput);
      this.searchSpec(this.specialtyInput);
    },
    searchProvider: async function(linkType) {
      this.form.ProviderOnly = this.modalPopup;
      if(linkType=='N'){
        this.form.currentPage +=1;
      }
      else if(linkType=='P'){
        if(this.form.currentPage >0){
          this.form.currentPage -=1;
        }
      }
      else{
        this.form.currentPage = 0;
      }
      this.form.offset = this.form.limit*this.form.currentPage;
      this.loading = true;
      this.providers = [];
      this.form.zipCodes = [];
      if (
        this.form.provSpecialty.length > 0 ||
        this.form.language.length > 0 ||
        this.form.gender.length > 0 ||
        !!this.form.ageband ||
        this.form.wheelchair.length > 0 ||
        this.form.translator.length > 0 ||
        this.form.newpatient.length > 0 ||
        this.form.providername != "" ||
        this.form.provHospital !== "" ||
        this.form.zipCode !== ""
      ) {
        this.searchCriteriaEntered = true;
        this.saveResp = await ProviderSearchService.getNearByZipCodes(
          this.form.zipCode,
          this.form.zipMiles
        );
        if (this.saveResp.length > 0) {
          this.center = this.saveResp[0].center;
          this.markers.push({
            position: this.saveResp[0].center,
            distance: "Your Zip Code, 0.00 miles",
            icon: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
          });
          this.saveResp.forEach(element => {
            this.form.zipCodes.push(element.zipcode);
            this.markers.push;
          });
        }
        if(this.form.FacilitySearch==1 && this.form.provSpecialty.length > 0){
          this.form.hospSpecialty = JSON.parse(JSON.stringify(this.form.provSpecialty));
        }else{
          this.form.hospSpecialty = [];
        }
        var providerList = await ProviderSearchService.findProvider(this.form);

        this.providers = providerList[0].records;
        this.recordCount = providerList[0].count;
        if (this.providers.length > 0) {
          this.providers.forEach((pro, idx) => {
            this.providers[idx].latLong =
                  "http://www.google.com/maps/search/?api=1&query="+pro.Street1 +' '+ (pro.Street2?pro.Street2+' ' : '')+ pro.City+' ' + pro.State +' '+ pro.Zip + ' ';
            this.saveResp.forEach(element => {
              if (pro.Zip == element.zipcode) {
                this.providers[idx].distance =
                  element.miles.toFixed(2) + " miles";
              }
            });
          });
          this.searchFlag = false;
          this.loading = false;
        } else {
          this.searchFlag = true;
          this.loading = false;
        }
      } else {
        this.searchCriteriaEntered = false;
        this.loading = false;
      }
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    changeInstrument: function(instrument) {
      this.activeInstrument = instrument;
    },
    toggleShow: function(val) {
      if (val == "hospital") {
        this.showHospitalMenu = !this.showHospitalMenu;
      }
      if (val == "product") {
        this.showProductMenu = !this.showProductMenu;
      }
      if (val == "specialty") {
        this.showSpecialtyMenu = !this.showSpecialtyMenu;
      }
      if (val == "language") {
        this.showLanguageMenu = !this.showLanguageMenu;
      }
      if (val == "gender") {
        this.showGenderMenu = !this.showGenderMenu;
      }
      if (val == "age") {
        this.showAgeMenu = !this.showAgeMenu;
      }
      if (val == "wheelchair") {
        this.showWheelchairMenu = !this.showWheelchairMenu;
      }
      if (val == "newpatient") {
        this.showNewpatientMenu = !this.showNewpatientMenu;
      }
      if (val == "translator") {
        this.showTranslatorMenu = !this.showTranslatorMenu;
      }
    },
    itemClicked: function(item) {
      this.toggleShow();
      this.onClick(item);
    },
    mouseOut: function(val) {
      this.active = false;
      this.showMenu = false;
      if (val == "hospital") {
        this.showHospitalMenu = false;
      }
      if (val == "product") {
        this.showProductMenu = false;
      }
      if (val == "specialty") {
        this.showSpecialtyMenu = false;
      }
      if (val == "language") {
        this.showLanguageMenu = false;
      }
      if (val == "gender") {
        this.showGenderMenu = false;
      }
      if (val == "age") {
        this.showAgeMenu = false;
      }
      if (val == "wheelchair") {
        this.showWheelchairMenu = false;
      }
      if (val == "newpatient") {
        this.showNewpatientMenu = false;
      }
      if (val == "translator") {
        this.showTranslatorMenu = false;
      }
    },
    removeThis: function(key, modelArr) {
      modelArr.splice(key, 1);
    },
    removeAge: function() {
      this.form.ageband= "";
    },
    searchLang: function(searchVal) {
      var tmpLang = [];
      if (searchVal) {
        this.orgLanguage.forEach(element => {
          var elementLowercase = element.text.toLowerCase();
          var searchValLowercase = searchVal.toLowerCase();
          if (elementLowercase.includes(searchValLowercase)) {
            tmpLang.push(element);
          }
        });
        this.languageFilter = tmpLang;
      } else {
        this.languageFilter = this.orgLanguage;
      }
    },
    searchSpec: function(searchVal) {
      var tmpSpec = [];
      if (searchVal) {
        this.orgSpec.forEach(element => {
          var elementLowercase = element.text.toLowerCase();
          var searchValLowercase = searchVal.toLowerCase();
          if (elementLowercase.includes(searchValLowercase)) {
            tmpSpec.push(element);
          }
        });
        this.specialtyFilter = tmpSpec;
      } else {
        this.specialtyFilter = this.orgSpec;
      }
    },
    decreaseFontSize: function () {
      if(this.fontSize>=12){
        this.fontSize -=1;
      }
      if(this.fontSizeSelect>=12){
        this.fontSizeSelect -=0.5;
      }
      if(this.headerFontSize>=15){
        this.headerFontSize -=1;
      }
    },
    increaseFontSize: function () {
      if(this.fontSize<=17){
        this.fontSize +=1;
      }
      if(this.fontSizeSelect<=13){
        this.fontSizeSelect +=0.5;
      }
      if(this.headerFontSize<=21){
        this.headerFontSize +=1;
      }
    }
  },
  computed: {
    cusFontSize() {
      return {
        "font-size": this.fontSize+'pt !important'
      };
    },
    customCard() {
      if(this.modalPopup){
        return {
          "cursor":"pointer"
        };
      }else {
        return {};
      }
    },
    cusHeaderFontSize() {
      return {
        "font-size": this.headerFontSize+'pt !important'
      };
    },
    cusFontSizeSelect() {
      return {
        "font-size": this.fontSizeSelect+'pt !important'
      };
    }

  }
};
</script>


<style scoped>
.provrow:hover {
  background-color: #f1f6f6;
}
.anchor {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  font-size:14px;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #fff;
  background-color: #25a7ce;
  border-color: #25a7ce;
}

.anchor::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.5em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.28em solid transparent;
  border-bottom: 0;
  border-left: 0.28em solid transparent;
}

.anchor:hover {
  color: #fff;
  background-color: #248cab;
  border-color: #268cab;
  cursor: pointer;
}

.menu {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  color: #212529;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  list-style: none;
  margin: 0.125rem 0 0;
  padding: 0.5rem 0.5rem;
  position: absolute;
  text-align: left;
  width: 97%;
  z-index: 1;
  margin-top: 0px !important;
}
.btn-info.disabled, .btn-info:disabled {
  cursor: default;
}
.btn-secondary.disabled, .btn-secondary:disabled {
  cursor: default;
}
span {
  font-weight: bold;
  color: #717573;
  /*font-size: 14px;*/
}
.textDesc{
  font-weight:normal;
  color: #2c3e50;
}
.selTags {
  color: #717573;
  background-color: #fff;
  border: #fff;
  border-right: 1px solid #717573;
  padding-right: 3px !important;
  border-radius: 0;
}

.closeTags {
  font-size: 14px;
}
.filterText {
  color: #25a7ce;
}
sub,
sup {
  font-size: 14px;
  margin-right: 2px;
}
sup:hover {
  color: red !important;
}
.zipBoxSm{
  display:none;
}
.customLabel {
  font-size: 14px;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
::-webkit-input-placeholder {
  color: #dde2e7;
  font-size: var(--font-size);
}
::-moz-placeholder {
  color: #dde2e7;
  font-size: 13px;
}
:-ms-input-placeholder {
  color: #dde2e7;
  font-size: 13px;
}
::placeholder {
  color: #dde2e7;
  font-size: 13px;
}
.selectCust1 {
  background: #fff
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.05rem center/8px 10px !important;
    width: 60px !important;
    padding-left: 15px !important;
}
.spinner {
  text-align: -webkit-center;
}
.hourBox{
  text-align:right;
  min-width:25pt;
}
.customTitle{
  color: #5A5C5E;
  font-weight: 600;
  font-size: 20pt;
  margin: 0;
  border-left: 2px solid #ccc;
  padding-left:10px;
}
.imgLogo {
  float: left;
  height: 113px;
}
@media screen and (min-width: 1000px) {
  .custPadding {
    padding: 0px !important;
  }
}
@media screen and (min-width: 1600px) {
  .custPadding {
    padding: 0px !important;
  }
}
@media screen and (min-width: 1900px) {
  .custPadding {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
}
@media screen and (max-width: 1300px) {
  .custFontHeader {
    font-size: 20px !important;
    margin-bottom: 5px;
  }
  .card-body {
    font-size: 12px;
  }
  span {
    font-size: 12px;
  }
}
@media screen and (max-width: 1024px) {
  .custom-checkbox {
    display:inline-block;
    margin-left:5px;
  }
  .hiddenSm{display:none}
  .hourBox{
    /*padding:0px 2px 0px 0px !important;*/
  }

}
@media screen and (max-width: 991px) {
  .zipBoxLg{
    display:none;
  }
  .zipBoxSm{
    display:block;
  }

}
@media screen and (max-width: 767px) {
  .hiddenXs{
    display:none;
  }

  .hourBox{
    text-align:left;
    /*margin-left: 15px !important;*/
    padding-left: 20px !important;
  }
}
/*@media only screen and (max-width: 768px) and (min-width: 520px)  {*/
/*  .hourBox{*/
/*    padding:0px 5px 0px 0px !important;*/
/*    padding-left: 15px !important;*/
/*  }*/
/*}*/
@media screen and (max-width: 520px) {
  .inner-box-right {
    border-right: none !important;
  }
  .hiddenXs{
    display:none;
  }
  .hourBox{
    text-align:left;
  }
  .imgLogo{
    float: none !important;
  }
  .selTags{
    border-right: 0px !important;
  }
  .tagBox{
    padding:0px !important;
  }
  .customTitle{
    border: none !important;
  }
  .titleBx{
    float: none !important;
    padding-top: 10px !important;
  }
  .selectCust1{
    width: 40px !important;
    padding-left: 6px !important;
    padding-right: 1px !important;
  }
}
</style>
